<template>
    <div class="compare-popup" :class="{ 
        'show': isVisible && compareList.length > 0,
        'loading': isLoading,
        'minimized': isMinimized
    }">
        <div v-if="!isMinimized" class="compare-popup__content">
            <button @click="toggleMinimize" class="compare-popup__minimize" tabindex="0">
                <span class="vh">{{ printString('minimize') }}</span>
                <span v-html="ico_minus_16"/>
            </button>
            <h3 class="step--3">
                {{ printString('compare') }}
            </h3>
            <p v-if="itemType === 'school'" class="paragraph--teaser margin--s-m">
                {{ printString('add_up_to_3_schools') }}
            </p>
            <p v-if="itemType === 'program'" class="paragraph--teaser margin--s-m">
                {{ printString('add_up_to_3_programs') }}
            </p>
            <ul class="compare-popup__list margin--s-m">
                <li class="compare-popup__item" v-for="item in compareList" :key="item.id">
                    <figure class="compare-popup__logo" v-if="item.img && item.img.src">
                        <img :src="item.img.src" :alt="item.name">
                    </figure>
                    <h4 v-if="item.name" class="paragraph--teaser">
                        {{ item.name }}
                    </h4>
                    <h4 v-else-if="item.program_name" class="paragraph--teaser">
                        {{ item.program_name }}
                    </h4>
                    <button @click="toggleCompare(item)">
                        <span class="vh">{{ printString('to_remove_from_compare') }}</span>
                        <span v-html="ico_close_16"/>
                    </button>
                </li>
            </ul>
            <button v-if="compareList.length > 0"
                    @click="goToComparePage" 
                    class="general-button orange-background-2"
                    :class="{ 'disabled': compareList.length < 2 }"
            >
                {{ printString('compare') }}
            </button>
        </div>
        <div v-else class="compare-popup__minimized">
            <h3 class="step--3">
                {{ printString('compare') }}
            </h3>
            <button @click="toggleMinimize" class="compare-popup__maximize" tabindex="0"> 
                <span class="vh">{{ printString('maximize') }}</span>
                <span v-html="ico_plus_16"/>
            </button>
        </div>
    </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';

export default {
    name: 'ComparePopup',
    props: {
        compareList: {
            type: Array,
            required: true
        },
        itemType: {
            type: String,
            required: true,
            validator: (value) => ['school', 'program'].includes(value)
        },
        isVisible: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            ico_compare_16: window.ico_compare_16,
            ico_close_16: window.ico_close_16,
            ico_minus_16: window.ico_minus_16,
            ico_plus_16: window.ico_plus_16,
            site_lang: window.lang,
            isMinimized: false,
        };
    },
    created() {
        console.log('SingleSchool component created');
        this.route = useRoute();
        this.router = useRouter();
    },
    computed: {
        itemTypeLabel() {
            return this.itemType === 'school' ? 'Schools' : 'Programs';
        }
    },
    watch: {
        compareList: {
            handler(newList, oldList) {
                if (newList.length === 0) {
                    this.$emit('hide-popup');
                } else if (!oldList || newList.length !== oldList.length) {
                    this.isMinimized = false;
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        toggleCompare(item) {
            console.log('Removing item:', item);
            if( this.itemType === 'school' ) {
                this.$emit('remove-from-compare', { 
                    id: item.id, 
                    altLangId: item.alt_lang_id
                });
            } else if ( this.itemType === 'program' ) {
                this.$emit('remove-from-compare', item.id);
            }
        },
        goToComparePage() {
            if( this.itemType === 'school' ) {
                // const route = this.site_lang === 'fr' ? '/fr/compare-schools' : '/compare-schools';
                const route = this.site_lang === 'fr' ? '/compare-schools' : '/compare-schools';
                this.router.push({ path: route });
            } else if ( this.itemType === 'program' ) {
                // const route = this.site_lang === 'fr' ? '/fr/compare-programs' : '/compare-programs';
                const route = this.site_lang === 'fr' ? '/compare-programs' : '/compare-programs';
                this.router.push({ path: route });
            }
        },
        printString(string) {
            return window.translations[string];
        },
        toggleMinimize() {
            this.isMinimized = !this.isMinimized;
        },
    }
}
</script>
